interface ParagraphWrapper {
  entity?: unknown | null
}

export default (list: Array<ParagraphWrapper | null> | null | undefined) => {
  return (
    list?.map((widget) => {
      const entity = widget?.entity as { __typename?: string } | undefined
      const typeName = entity?.__typename?.replace('Paragraph', '') || ''
      const name = `Section${typeName}`
      return {
        name,
        entity: widget?.entity,
      }
    }) || []
  )
}
